import { FunctionsHttpError } from '@supabase/supabase-js';
import { supabase } from '@/integrations/supabase/client';

export const CONNECTOR = 'google_drive';

export type DriveStatus = {
  enabled: boolean;
  canManage: boolean;
  connected: boolean;
  reconnectRequired?: boolean;
  googleEmail: string | null;
};

export async function callDrive<T>(body: Record<string, unknown>): Promise<T> {
  const { data, error } = await supabase.functions.invoke('google-drive', { body });
  if (error) {
    let msg = 'Something went wrong with Google Drive.';
    if (error instanceof FunctionsHttpError) {
      const parsed = await error.context.json().catch(() => null);
      if (parsed?.error && typeof parsed.error === 'string' && !parsed.request_id) msg = parsed.error;
    }
    throw new Error(msg);
  }
  return data as T;
}

export function waitForPopup(popup: Window) {
  return new Promise<string>((resolve, reject) => {
    const cleanup = () => {
      window.removeEventListener('message', onMessage);
      window.clearInterval(poll);
    };
    const onMessage = (event: MessageEvent) => {
      const type = event.data?.type;
      if (event.origin !== window.location.origin || event.source !== popup || event.data?.connectorId !== CONNECTOR) return;
      if (type !== 'appUserConnectorOAuthCode' && type !== 'appUserConnectorOAuthFailed') return;
      cleanup();
      popup.close();
      if (type === 'appUserConnectorOAuthCode' && typeof event.data?.code === 'string') resolve(event.data.code);
      else {
        reject(new Error(event.data?.reason ?? 'Google Drive was not connected.'));
      }
    };
    window.addEventListener('message', onMessage);
    const poll = window.setInterval(() => {
      if (!popup.closed) return;
      cleanup();
      reject(new Error('The Google window closed before finishing.'));
    }, 500);
  });
}

